<div class="lcl-quote-total-cost-container">
  <span class="lcl-quote-total-cost-container__header">{{ "LCL_SHIPMENT.DASHBOARD.CURRENT_TOTAL_COST" | translate }}:</span>
  <span class="lcl-quote-total-cost-container__price">{{ price | currency }}</span>
  <div class="lcl-quote-total-cost-container__button" (click)="bookQuote($event)">
    <span>{{ "BUTTON.BOOK_NOW" | translate }}</span>
  </div>
  <div class="lcl-quote-total-cost-container__validity">
    {{ "LABELS.QUOTE_VALIDITY" | translate }}:
    <span class="date">{{ validity | date : formatDateTime }}</span>
  </div>
</div>
